export default __webpack_public_path__ + "static/media/11.a8c45583.JPG";